///-- THIS FILE IS GENERATED --///
export enum BackgroundAttachment {

    BG_FIXED = "pinata-bg-fixed",

    BG_LOCAL = "pinata-bg-local",

    BG_SCROLL = "pinata-bg-scroll",

}